import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CanteenRole } from 'core/models/canteen.model';
import { CanteenService } from 'core/services/canteen.service';

export function canteenRoleGuard(
  ...roles: readonly CanteenRole[]
): CanActivateFn {
  return () => {
    const canteen = inject(CanteenService);
    const router = inject(Router);
    if (!canteen.signedIn()) {
      return router.createUrlTree(['/dashboard']);
    }
    return roles.includes(canteen.role())
      ? true
      : router.createUrlTree(['/dashboard']);
  };
}
